import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

const RightChevronIcon = props => {
  return (
    <Svg
      width={6}
      height={10}
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M5.146 5.354L1.354 9.146A.5.5 0 01.5 8.793V1.207a.5.5 0 01.854-.353l3.792 3.792a.5.5 0 010 .708z"
        fill="#8697AB"
      />
    </Svg>
  );
};

export default RightChevronIcon;
